import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { BehaviorSubject } from 'rxjs';
import { SYNC_REQUEST_TYPE } from '../../enums/sync-request-type.enum';
import { SyncQueueInterface } from '../../interfaces/sync-queue.interface';
import { SyncRequestModel } from './sync-request.model';

@Injectable()
export class SyncQueueService implements SyncQueueInterface {
    private syncRequestSubject = new BehaviorSubject<SyncRequestModel[]>([]);
    public syncRequest$ = this.syncRequestSubject.asObservable();
    public constructor(@Inject(LogInstanceToken) private readonly log: LogInterface) {}

    public addSyncRequest(syncRequestType: SYNC_REQUEST_TYPE, triggerSyncEvent = true): void {
        this.addSynchronizationRequest(syncRequestType, triggerSyncEvent);
    }

    public removeSynchronizationRequest(syncRequestModel: SyncRequestModel): void {
        const filteredSyncRequests = this.syncRequestSubject.value.filter(
            (request) => request.syncRequestType !== syncRequestModel.syncRequestType,
        );
        this.syncRequestSubject.next(filteredSyncRequests);
    }

    private addSynchronizationRequest(syncType: SYNC_REQUEST_TYPE, triggerSyncEvent: boolean): void {
        const syncRequests = this.syncRequestSubject.value;
        const syncRequest = new SyncRequestModel(syncType, triggerSyncEvent);
        this.log.debug('SyncQueueService: addSynchronizationRequest: Checking to add -> ' + syncRequest.toString());
        const syncRequestOfSameType = syncRequests.find((request: SyncRequestModel) => {
            return request.syncRequestType === syncType && request.triggerSyncEvent === triggerSyncEvent;
        });
        if (!syncRequestOfSameType) {
            syncRequests.push(syncRequest);
            this.syncRequestSubject.next(syncRequests);
            this.log.debug(`SyncQueueService: addSynchronizationRequest: ${syncRequests.length} in queue now`);
        } else {
            this.log.debug('SyncQueueService: addSynchronizationRequest: sync request not added');
        }
    }
}
